export default __webpack_public_path__ + "accounting-central-logo-no-background.0da983db.png";